export default __webpack_public_path__ + "static/media/GPA_Banner_CustomerSupport.778cdf3e.png";